import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import { store } from '../config/store.ts';

export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || 'https://dev-eos.porstendorfer.net/';

export const GTM_ID = import.meta.env.VITE_GTM_ID || '';

export const createApiInstance = (): AxiosInstance => {
  const instance = axios.create({
    baseURL: API_BASE_URL,
    paramsSerializer: { indexes: null },
  });

  instance.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
      const token = store.tokenObject.value.auth?.token;
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      } else {
        console.log('No token found');
      }
      return config;
    },
    (error) => Promise.reject(error),
  );

  return instance;
};
